
import {Component, Prop, Vue} from "vue-property-decorator";
import OnboardingSlide from "../OnboardingSlide.vue";
import Keyboard from "../../../musical-components/keyboard/Keyboard.vue";
import {midiDispatcher} from "../../../midi/MidiDispatcher";
import {Division} from "../../../playable/models/Division";
import {userService} from "../../../user/UserService";
import {isInMobileApp} from "src/utils/MobileUtils";
import TeacherIcon from "src/modules/teacher/TeacherIcon.vue";

@Component({
  components: {TeacherIcon, Keyboard, OnboardingSlide}
  })
export default class PlugKeyboardSlide extends Vue {
  @Prop({default: false}) noBackButton: boolean;

  private midiNoteStatus: 'TO_LOW' | 'TO_HIGH' | 'NONE' = 'NONE'
  private pressedKey = false;
  private step: 'pressKey' | 'onboardingCompleted' = 'pressKey';

  private readonly simpleTutorialDivision = new Division();

  private holdProgress = 0
  private holdTimer: number | null = null
  private holdStartTime = 0
  private HOLD_DURATION = 2000

  get isMobile() {
    return isInMobileApp();
  }

  get plugHelpText() {
    return this.isMidiActive
      ? this.$t('onboardingPlugKeyboardSlide.helpPlug')
      : this.$t('onboardingPlugKeyboardSlide.helpMidi');
  }

  get isMidiActive() {
    return midiDispatcher.state.isActive;
  }

  mounted() {
    midiDispatcher.initMidiDispatcher();
  }

  created() {
    midiDispatcher.on('notePlayed', this.onNotePlayed);
    midiDispatcher.on('notesStopped', this.onNotesStopped);

    this.simpleTutorialDivision.currentHandprint = [
      {
        key: 40,
        hand: 'RIGHT',
        finger: '1',
        noteStatus: 2,
        duration: -1,
        name: {FR: 'Do', EN: 'C'},
      },
    ];
  }

  beforeDestroy() {
    midiDispatcher.off('notePlayed', this.onNotePlayed);
    midiDispatcher.off('notesStopped', this.onNotesStopped);
    if (this.holdTimer) {
      clearInterval(this.holdTimer);
      this.holdTimer = null;
    }
  }

  onNotePlayed(note) {
    this.pressedKey = true;
    if (note.key === 40) {
      this.startHoldTimer();
      this.midiNoteStatus = 'NONE';
    }
    else {
      this.resetHold();
      if (note.key < 28) {
        this.midiNoteStatus = 'TO_LOW';
      }
      else if (note.key > 52) {
        this.midiNoteStatus = 'TO_HIGH';
      }
    }
  }


  onNotesStopped(note) {
    if (note.key === 40) {
      this.resetHold();
    }
  }

  startHoldTimer() {
    if (this.holdTimer) {
      return;
    }

    this.holdProgress = 0;
    this.holdStartTime = Date.now();

    this.holdTimer = window.setInterval(() => {
      const elapsed = Date.now() - this.holdStartTime;
      this.holdProgress = elapsed / this.HOLD_DURATION;

      if (this.holdProgress >= 1) {
        this.holdProgress = 1;

        this.step = "onboardingCompleted"

        if (this.holdTimer) {
          clearInterval(this.holdTimer);
          this.holdTimer = null;
        }
      }
    }, 100);
  }

  resetHold() {
    this.holdProgress = 0;
    if (this.holdTimer) {
      clearInterval(this.holdTimer);
      this.holdTimer = null;
    }
  }

  openMidiHelp() {
    // @ts-ignore
    this.MobileBrowser.openInAppBrowser('https://survey.qwary.com/form/S_wSzSPnasH9Wc_FT15X0J1BuEcPl5gIya8Ck-6hqjM=');
  }

  completePlugPiano() {
    const userOnboardingConfigCopy = { ...userService.user.configurations.onboardingConfig };
    userOnboardingConfigCopy.hasFinishedMidiOnboarding = true;
    userService.updateConfiguration('ONBOARDING', userOnboardingConfigCopy);

    this.$emit('loadNextSlide');
    this.$emit('pianoPlugged');
  }

  goBack() {
    if (this.step === 'onboardingCompleted') {
      this.step = 'pressKey';
    }
    else {
      this.$emit('back');
    }
  }
}
